import React, {useState} from 'react'
import {withTranslation} from 'react-i18next'

import BButton from 'components/Form/Fields/BButton'

const CookiesHandler = ({t}) => {
  const [hidden, setHidden] = useState(localStorage.getItem('cookiesAgreed') ? JSON.parse(localStorage.getItem('cookiesAgreed')) : false)

  const cookiesOk = () => {
    setHidden(true)
    localStorage.setItem('cookiesAgreed', 'true')
  }

  return (
    !hidden && (
      <div className='cookiesHandler'>
        <div>
          <div>
            <div>
              {t('By continuing to browse this site you agree to the storing of \'cookies\' on your device to enhance your experience.')}
            </div>
            <div>
              <BButton white bordered onClick={cookiesOk}>{t('Accept & close')}</BButton>
            </div>
          </div>
        </div>
      </div>
    )
  )
}

export default withTranslation()(CookiesHandler)
